import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Task } from '../../../../shared/entities/task/task';
import { ControlTemplate } from '../../../form/entities/controlTemplate';
import { ViewDialogService } from '../../../../../core/components/viewDialog/viewDialogService';
import { CommandTemplate } from '../../../../../core/entities/commandTemplate/commandTemplate';
import { TaskFormHandler } from '../task-form-handler.interface';
import { OperatedRentalUserTaskFormHandler } from '../operated-rental-user-task-form.handler';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormViewDialogComponent } from './form-view-dialog.component';

/**
 * View component for operatedRentalUserTaskForm tasks.
 */
@Component({
  selector: 'app-operated-rental-user-task-form-view',
  template: `
    <div class="top flex flex-col px-5 py-[0.313rem] bg-white min-w-[485px] block border-b border-gray first:border-t ng-star-inserted">
        <div class="flex flex-row items-center">
        <div class="grow">
            <div class="flex flex-row">
                <div class="text-base font-medium leading-3r">
                    {{task()?.description}}
                </div>
            </div>
        </div>
        @if (!isNotCompleted()) {
        <div class="self-center">
            <nx-default-button
            [style]="'dark'"
            (click)="view()"
            [disabled]="false"
            [icon]="'icon-search'">
            </nx-default-button>
        </div>
        }
        </div>
    </div>
    <div class="flex justify-end mt-2">
      @if(isNotCompleted()) {
      <nx-default-button
        [style]="'accent'"
        [disabled]="disabled()"
        [pTooltip]="disabled() ? 'Im Web nicht verfügbar.' : undefined"
        [label]="template()?.settings?.startLabel">
      </nx-default-button>
      } @else {
      <nx-default-button
        [style]="'accent'"
        [disabled]="true"
        [label]="'Erledigt'">
      </nx-default-button>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OperatedRentalUserTaskFormViewComponent {
  readonly task = input.required<Task>();
  readonly template = input<ControlTemplate | null>(null);
  readonly commandTemplate = input<CommandTemplate | null>(null);
  readonly disabled = input(true);
  readonly handler = input.required<TaskFormHandler>();

  readonly complete = output<void>();

  readonly isNotCompleted = computed(() => this.task()?.state !== 'COMPLETED');

  // Type-safe accessor for the specific handler
  readonly operatedRentalHandler = computed(
    () => this.handler() as OperatedRentalUserTaskFormHandler
  );

  dialogRef: DynamicDialogRef | undefined;

  private readonly viewDialogService = inject(ViewDialogService);

  view() {
    this.dialogRef = this.viewDialogService.open(FormViewDialogComponent, {
      header: this.template()?.settings?.label,
      closeLabel: 'Schließen',
      width: '800px',
      data: {
        template: this.template()
      }
    });
    
    this.dialogRef.onClose.subscribe((result) => {
      if (result) {
        this.complete.emit(result);
      }
    });
  }
}
